// Module
var code = "<div class=\"application-info\"> </div> <div class=\"nodes-content\"></div> ";
// Exports
export default code;